import { isEmpty as isHtmlEmpty } from '@paintscout/util/util'
import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty({ section, isPrint }: PresentationIsEmptyProps) {
  if (isPrint) {
    return true
  }

  const fields = section?.fields
  if (!fields) {
    return true
  }

  if (!fields.rows || fields.rows.length === 0) {
    return true
  }

  return fields.rows.reduce((acc, row) => {
    const hasContent = row?.content && !isHtmlEmpty(row.content)
    const emptyRow = !hasContent && !row?.title && !row?.image

    return acc && emptyRow
  }, true)
}
